module.exports = __webpack_public_path__ + "static/media/anidride_solforosa.85de61d3.svg";